export enum Permission {
  FulfillmentEventsView = 'fulfillment_events.view',
  FulfillmentEventsModify = 'fulfillment_events.modify',
}
